import IsLoading from "components/Shared/IsLoading"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Button, Table } from "reactstrap"
import { getMatchedCandidatesList } from "store/actions/interviewsAction"

const MatchedCandidates = ({ values }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { loading2, matchedCandidatesList, totalCount } = useSelector(
    state => state.Interviews
  )

  useEffect(() => {
    const getAllData = () => {
      const {
        city_ids,
        specialization_id,
        gender,
        nationality_id,
        education_qualification_id,
        employee_experience,
        employee_experience_as_per_document,
        national_ids,
      } = values
      const updatedCitiesId = city_ids?.map(item => item.value) || []

      const nationalIdArray = [
        ...new Set(
          national_ids
            .split(",")
            .map(id => id.trim())
            .filter(id => id !== "") // Remove empty strings
        ),
      ]

      const data = {
        limit: 100,
        page_number: 1,
        order_by: 1,
        filters: {
          city_ids: updatedCitiesId,
          specialization_id,
          gender,
          nationality_id,
          education_qualification_id,
          employee_experience,
          employee_experience_as_per_document,
          national_ids: nationalIdArray,
          // "keyword": ""
        },
      }

      dispatch(getMatchedCandidatesList(data))
    }

    getAllData()
  }, [])

  return (
    <div>
      {loading2 ? (
        <IsLoading />
      ) : (
        <div className="table-responsive" style={{ maxHeight: "90vh" }}>
          <div className="d-flex justify-content-end mb-4">
            {matchedCandidatesList?.length > 0 && (
              <Button color="success" className="px-2">
                Download CSV
              </Button>
            )}
          </div>
          {matchedCandidatesList?.length === 0 ? (
            <p className="text-center my-5 fs-4 font-bold">
              No matching data found
            </p>
          ) : (
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  <th>{t("S. No")}</th>
                  <th>{t("National Id")}</th>
                  <th>{t("Name")}</th>
                  {/* <th>{t("Email")}</th> */}
                  <th>{t("Phone Number")}</th>
                  <th>{t("DOB")}</th>
                  <th>{t("Gender")}</th>
                  <th>{t("Nationality")}</th>
                  <th>{t("City")}</th>
                  <th>{t("Education Qualification")}</th>
                  <th>{t("Specialization")}</th>
                  <th>{t("Submitted Experience")}</th>
                  <th>{t("System Experience")}</th>
                </tr>
              </thead>
              <tbody>
                {matchedCandidatesList?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.national_id}</td>
                    <td>{item?.full_name}</td>
                    {/* <td>{item?.email}</td> */}
                    <td>{item?.phone}</td>
                    <td>{item?.dob}</td>
                    <td className="text-capitalize">{item?.gender}</td>
                    <td>{item?.nationality_name}</td>
                    <td>{item?.city_name}</td>
                    <td>{item?.education_qualification_name}</td>
                    <td>{item?.specialization_name}</td>
                    <td>{item?.submit_experience === 1 ? "Yes" : "No"}</td>
                    <td>{}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      )}
    </div>
  )
}

export default MatchedCandidates
